/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Error_Members_RequiredInputs */

const en_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share must include at least one team member.`)
};

const fr_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le partage doit inclure au moins un membre de l’équipe.`)
};

const de_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Beitrag muss mindestens ein Teammitglied enthalten.`)
};

const it_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La quota deve includere almeno un membro del team.`)
};

const ru_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В состав команды должен входить как минимум один участник.`)
};

const es_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La acción debe incluir al menos un miembro del equipo.`)
};

const zh_cn2_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享者必须至少包含一名团队成员。`)
};

const ja_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有には少なくとも 1 人のチーム メンバーを含める必要があります。`)
};

const hi_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर में कम से कम एक टीम सदस्य शामिल होना चाहिए।`)
};

const pt_pt2_team_share_error_members_required = /** @type {(inputs: Team_Share_Error_Members_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O compartilhamento deve incluir pelo menos um membro da equipe.`)
};

/**
* | output |
* | --- |
* | "Share must include at least one team member." |
*
* @param {Team_Share_Error_Members_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_error_members_required = /** @type {((inputs?: Team_Share_Error_Members_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Error_Members_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_error_members_required(inputs)
	if (locale === "de") return de_team_share_error_members_required(inputs)
	if (locale === "it") return it_team_share_error_members_required(inputs)
	if (locale === "ru") return ru_team_share_error_members_required(inputs)
	if (locale === "es") return es_team_share_error_members_required(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_error_members_required(inputs)
	if (locale === "ja") return ja_team_share_error_members_required(inputs)
	if (locale === "hi") return hi_team_share_error_members_required(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_error_members_required(inputs)
	return en_team_share_error_members_required(inputs)
});